var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRadius2Icon = function SvgRadius2Icon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.75 3.75A5.25 5.25 0 0 0 4.5 9v3.5a.5.5 0 0 1-.5.5h-.5a.5.5 0 0 1-.5-.5V9a6.75 6.75 0 0 1 6.75-6.75h3.5a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5h-3.5Z",
    clipRule: "evenodd"
  })));
};
export default SvgRadius2Icon;